import { 
    LOAD_LIST_SERVICE_PRICE, LOAD_A_SERVICE_PRICE, ADD_NEW_SERVICE_PRICE, UPDATE_A_SERVICE_PRICE, 
    DELETE_A_SERVICE_PRICE, CLEAR_A_SERVICE_PRICE_DETAIL, CLEAR_SERVICE_PRICE_ACTION_STATUS, 
    DOC_EXPORT_SERVICE_PRICE_LIST_TO_CSV, CLEAR_SERVICE_PRICE_LIST_REMOTE_CSV, DOC_EXPORT_SERVICE_PRICE_LIST_TO_EXCEL, CLEAR_SERVICE_PRICE_LIST_REMOTE_EXCEL
} from '../actionTypes';
import { SUCCESS_STATUS, FAILED_STATUS } from '../../constants';

const initialState = {
    servicePriceList: [],
    servicePriceDetail: null,
    totalCount: 0,
    limit: 10,
    offset: 0,
    loading: false,
    error: '',
    actionStatus: undefined,
    actionMsg: "",
    remoteCSV: null,
    remoteEXCEL: null,
};

export default function(state = initialState, action) {
    switch(action.type) {
        case LOAD_LIST_SERVICE_PRICE: {
            const { result, totalCount, limit, offset } = action.payload;
            return {
                ...state,
                servicePriceList: result,
                totalCount,
                limit, 
                offset
            }
        }

        case LOAD_A_SERVICE_PRICE: {
            return {
                ...state,
                servicePriceDetail: action.payload
            }
        }

        case ADD_NEW_SERVICE_PRICE: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                servicePriceList: [
                    action.payload.data,
                    ...state.servicePriceList
                ],
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case UPDATE_A_SERVICE_PRICE: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                servicePriceList: state.servicePriceList.map(item => item.id !== action.payload.data.id ? item : action.payload.data),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case DELETE_A_SERVICE_PRICE: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

    
            
            return {
                ...state,
                loading: false,
                servicePriceList: state.servicePriceList.filter(item => item.id !== parseFloat(action.payload.data)),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case CLEAR_A_SERVICE_PRICE_DETAIL: {
            return {
                ...state,
                servicePriceDetail: null,
            }
        }

        case CLEAR_SERVICE_PRICE_ACTION_STATUS: {
            return {
                ...state,
                actionStatus: undefined,
                actionMsg: ""
            }
        }
        
        case DOC_EXPORT_SERVICE_PRICE_LIST_TO_CSV.SUCCESS:
            return {
                ...state,
                remoteCSV: action.payload,
            };

        case CLEAR_SERVICE_PRICE_LIST_REMOTE_CSV: {
            return {
                ...state,
                remoteCSV: null,
            };
        }

        case DOC_EXPORT_SERVICE_PRICE_LIST_TO_EXCEL.SUCCESS:
            return {
                ...state,
                remoteEXCEL: action.payload,
            };

        case CLEAR_SERVICE_PRICE_LIST_REMOTE_EXCEL: {
            return {
                ...state,
                remoteEXCEL: null,
            };
        }

        default:
            return state
    }
}